var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "call-to-action call-to-action--with-border bg-white border-radius p-4",
      on: {
        click: function($event) {
          return _vm.open(
            "https://catuxolessons.talentlms.com/catalog/index?utm_source=cat-uxo"
          )
        }
      }
    },
    [_vm._m(0)]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "call-to-action__content" }, [
      _c("div", { staticClass: "call-to-action__heading mb-2" }, [
        _vm._v("Explore our training lessons.")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "call-to-action__paragraph mb-12px t-navy" }, [
        _vm._v(
          "For a better understanding of EOD doctrine,\n            access our online EOD lessons and receive a CAT-UXO certificate (EOD Level 1 to 3) to\n            confirm your technical knowledge and competence."
        )
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "btn-icon-text btn-navy",
          attrs: {
            target: "_blank",
            href:
              "https://catuxolessons.talentlms.com/catalog/index?utm_source=cat-uxo"
          }
        },
        [
          _vm._v("Find out more "),
          _c("i", { staticClass: "icon icon__arrow-right-navy" })
        ]
      )
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cd67c6d0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cd67c6d0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/CallToActionOutline.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-cd67c6d0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/CallToActionOutline.vue
// module chunks = 0 1